import styled from 'styled-components'

export const StyledFooter = styled.div<{ isSingleColumn: boolean }>`
  display: grid;
  grid-template-columns: ${({ isSingleColumn }) =>
    isSingleColumn ? '1fr' : '1fr 1fr'};
  padding: 0 1rem 0.75rem;
  gap: 0.5rem;
`
